import { FelaCSS, FelaCSSWithCustomSelectors } from '@bridebook/ui';

interface IStyles {
  stackedIconsWrap: FelaCSS;
  stackedIcon: FelaCSSWithCustomSelectors;
}

const styles = (iconWidth: number): IStyles => ({
  stackedIconsWrap: {
    display: 'inline-flex',
    flexDirection: 'row',
  },

  stackedIcon: {
    '&:not(:first-child)': {
      marginLeft: `-${iconWidth / 2}px`,
    },
  },
});

export default styles;
